import React, { Component } from 'react';
import { Row, Col, Container } from 'react-bootstrap';

class Careers extends Component {
    render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>

                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <h2 className="h4 mt-4 text-black text-center text-uppercase">Careers</h2>
                        <hr />
                    </Col>
                </Row>
                <Row><br/></Row>
            </Container>
        )
    }
}

export default Careers;